var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VcToast',{key:_vm.toastId,attrs:{"value":_vm.toastConfig.value,"header-text":_vm.toastConfig.headerText,"body-text":_vm.toastConfig.bodyText,"type":_vm.toastConfig.type,"timeout":_vm.toastConfig.timeout,"identifier":_vm.toastConfig.identifier}})
}
var staticRenderFns = []

export { render, staticRenderFns }